module.exports = "/_next/static/images/1758d0cbb33e982b3c2cbb355961629d-el-pais.png.webp";